import {callApi} from "./rest.js";

const ROOT_URL = '/api/genes';

export const getGeneSuggestion = async (query) => {
    const url = `${ROOT_URL}/suggest?q=${query}`;
    return await callApi(url, "GET");
};